export const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent);

export const useNavigator = () => {
  const userAgent = window.navigator.userAgent;
  return {
    isIOS: isIOS(),
    isStandalone:
      ('standalone' in window.navigator && window.navigator.standalone) ||
      window.matchMedia('(display-mode: standalone)').matches,
    isIPadOS: navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1,
    userAgent,
    isIE: userAgent.indexOf('MSIE ') > 0 || userAgent.indexOf('Trident/') > 0,
    isEdge: userAgent.indexOf('Edge/') > 0,
    isFirefox: userAgent.indexOf('Firefox') > 0
  };
};
